import React from 'react';

function Archive() {
  const events = [
    {
      id: 13,
      title: 'ВДА: взрослые дети алкоголиков',
      date: '07 февраля 2026',
      imageUrl: '/images/07.02.jpg',
    },
    {
      id: 12,
      title: 'У каждого есть свой шарик',
      date: '31 января 2026',
      imageUrl: '/images/31.01.jpg',
    },
    {
      id: 11,
      title: 'Формула года: осмысленные итоги прошлого и грамотные цели будущего',
      date: '20 декабря 2025',
      imageUrl: '/images/20.12.jpg',
    },
    {
      id: 10,
      title: 'Фокус на себе: как фотографии говорят о нас больше, чем слова',
      date: '13 декабря 2025',
      imageUrl: '/images/13.12.jpg',
    },
    {
      id: 9,
      title: 'Измены',
      date: '06 декабря 2025',
      imageUrl: '/images/cc.jpg',
    },
    {
      id: 8,
      title: 'Климат ваших отношений: в каком сезоне вы находитесь?',
      date: '29 ноября 2025',
      imageUrl: '/images/dd.jpg',
    },
    {
      id: 7,
      title: 'Кризисы в отношениях: как не бояться и преодолевать',
      date: '22 ноября 2025',
      imageUrl: '/images/hh.jpg',
    },
    {
      id: 6,
      title: '5 языков любви',
      date: '22 ноября 2025',
      imageUrl: '/images/kk.jpg',
    },
    {
      id: 5,
      title: 'Причины и лечение психологических страданий: краткая история психоанализа',
      date: '15 ноября 2025',
      imageUrl: '/images/ee.jpg',
    },
    {
      id: 4,
      title: 'Всё самое важное о сне и сновидениях',
      date: '8 ноября 2025',
      imageUrl: '/images/ff.jpg',
    },
    {
      id: 3,
      title: 'Погружение в свой страх',
      date: '25 октября 2025',
      imageUrl: '/images/jj.jpg',
    },
    {
      id: 2,
      title: 'В нашей ассоциации состоялся семинар с Лявасом Коварскис!',
      date: '20 октября 2025',
      imageUrl: '/images/aaa.jpg',
    },
    {
      id: 1,
      title: 'Сепарация. Как научиться жить своей жизнью и не зависеть от мнения окружающих?',
      date: '18 октября 2025',
      imageUrl: '/images/bb.jpg',
    },
  ];

  return (
    <div
      style={{
        backgroundColor: 'white',
        color: 'var(--dark-blue)',
        fontFamily: "'Arial', sans-serif",
        padding: '40px 0',
        minHeight: '100vh',
      }}
    >
      {/* Заголовок */}
      <div
        className="container"
        style={{
          maxWidth: '1000px',
          margin: '0 auto',
          padding: '0 16px',
          textAlign: 'center',
          marginBottom: '40px',
        }}
      >
        <h1
          style={{
            fontSize: '1.8rem',
            fontWeight: '700',
            color: 'var(--navy-blue)',
            margin: '0 0 16px',
            lineHeight: '1.3',
          }}
        >
          Архив мероприятий
        </h1>
      </div>

      {/* Сетка карточек */}
      <div
        style={{
          maxWidth: '1200px',
          margin: '0 auto',
          padding: '0 16px',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '24px',
        }}
      >
        {events.map((event) => (
          <div
            key={event.id}
            style={{
              backgroundColor: 'white',
              border: '1px solid #e2e8f0',
              borderRadius: '12px',
              overflow: 'hidden',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.06)',
              width: '100%',
            }}
          >
           {/* Изображение */}
<div
  style={{
    width: '100%',
    height: '480px',
    backgroundColor: '#f8fafc',
    overflow: 'hidden',
  }}
>
  <img
    src={event.imageUrl}
    alt={event.title}
    style={{
      width: '100%',
      height: '100%',
      display: 'block',
      objectFit: 'contain',
      objectPosition: 'center',
    }}
    onError={(e) => {
      e.currentTarget.style.display = 'none';
    }}
  />
</div>

            {/* Текст */}
            <div style={{ padding: '16px' }}>
              <div
                style={{
                  fontSize: '0.9rem',
                  color: 'var(--text-gray)',
                  marginBottom: '6px',
                }}
              >
                {event.date}
              </div>

              <h3
                style={{
                  fontSize: '1.15rem',
                  fontWeight: '600',
                  margin: 0,
                  color: 'var(--navy-blue)',
                  lineHeight: '1.3',
                }}
              >
                {event.title}
              </h3>
            </div>
          </div>
        ))}
      </div>

      {/* На главную */}
      <div
        style={{
          textAlign: 'center',
          marginTop: '40px',
          padding: '0 16px',
          marginBottom: '30px',
        }}
      >
        <a
          href="/"
          className="btn"
          style={{
            backgroundColor: 'var(--button-blue)',
            color: 'var(--white)',
            padding: '12px 24px',
            textDecoration: 'none',
            borderRadius: '8px',
            fontWeight: 'bold',
            display: 'inline-block',
            fontSize: '1rem',
          }}
        >
          На главную
        </a>
      </div>
    </div>
  );
}

export default Archive;